import { createEmitter } from './emitter';

// Lets feature modules hook into auth cleanup without AuthProvider knowing
// them.
const cleanupEmitter = createEmitter();
const survivorKeys = new Set<string>();

export const onLogoutCleanup = cleanupEmitter.subscribe;
export const notifyLogoutCleanup = cleanupEmitter.notify;

export function registerLogoutStorageSurvivor(key: string): () => void {
  survivorKeys.add(key);
  return () => {
    survivorKeys.delete(key);
  };
}

export function clearStorageKeepingSurvivors(storage: Storage | undefined): void {
  if (!storage) return;
  const survivors: Array<[string, string]> = [];
  for (const key of survivorKeys) {
    const value = storage.getItem(key);
    if (value !== null) survivors.push([key, value]);
  }
  storage.clear();
  for (const [key, value] of survivors) {
    storage.setItem(key, value);
  }
}
